define(function(require,exports,module){
	function parentAndChild(parent,child){
	    return parent && child && child.parentNode===parent;
	}

	return {
		remove : function(parent,child){
			if(!child){
				child=parent;
				parent=child && child.parentNode;
			}
			if(parentAndChild(parent,child)){
				parent.removeChild(child);
				return true;
			}
			return false;
		},
		append : function(parent,child){
			if(parent && child){
				parent.appendChild(child);
				return true;
			}
			return false;
		},
		create : document.createElement
	}
});